import { Injectable } from "@angular/core";
import { Observable, shareReplay } from "rxjs";
import { AktTitelResponse } from "../../api/models/akt-titel-response";
import { FairAppRequest } from "../../api/models/fair-app-request";
import { TitelService } from "../../api/services/titel.service";

@Injectable({ providedIn: "root" })
export class AktTitelCacheService {
  private static readonly TTL_MS = 10 * 60 * 1000;
  private cache = new Map<number, Observable<AktTitelResponse>>();
  private timestamps = new Map<number, number>();

  constructor(private titelService: TitelService) {}

  getTitel(params: FairAppRequest): Observable<AktTitelResponse> {
    const aktId = Number(params.akt_id);
    if (this.cache.has(aktId) && Date.now() - this.timestamps.get(aktId) > AktTitelCacheService.TTL_MS) {
      this.cache.delete(aktId);
      this.timestamps.delete(aktId);
    }
    if (!this.cache.has(aktId)) {
      this.timestamps.set(aktId, Date.now());
      this.cache.set(aktId, this.titelService.titelRetrieveCreate(params).pipe(shareReplay({ bufferSize: 1, refCount: false })));
    }
    return this.cache.get(aktId);
  }
}
